import {Record} from "./Record";

export class User extends Record {
    email: string = ""
    display_name: string = ""
}
